import fontsStyles from '../../../../styles/modules/fonts.module.scss';
import type { VariantType } from '../../../../types';
import styles from './WChanceCardHeader.module.scss';
import raffleStyles from './WChanceCardHeader.raffle.module.scss';

export interface WChanceCardHeaderProps {
  showHeaderDescription?: boolean;
  headerDescription?: string;
  headerText?: string;
  headerAnnotation?: string;
  variant?: VariantType;
}

function WChanceCardHeader({
  showHeaderDescription = false,
  headerDescription = 'くじ1回毎に特別な景品が当たるチャンス！',
  headerText = 'チャンス賞',
  headerAnnotation,
  variant = 'default',
}: WChanceCardHeaderProps) {
  // variantに応じてスタイルを決定
  // var(--color-primary) を使用しているので、出し分ける
  const currentStyles = variant === 'raffle' ? raffleStyles : styles;
  return (
    <>
      {showHeaderDescription && <div className={currentStyles.headerDescription}>{headerDescription}</div>}
      <div className={currentStyles.headerWrapper}>
        <div className={currentStyles.header}>
          <span className={`${fontsStyles.montserrat} ${currentStyles.wLetter}`}>W</span>
          {headerText}
        </div>
        {headerAnnotation && <div className={currentStyles.headerAnnotation}>{headerAnnotation}</div>}
      </div>
    </>
  );
}

export default WChanceCardHeader;
